export const mockCases = [
    {
        id: 1,
        customerName: 'Acme Corp',
        amountOwed: 5000,
        daysOverdue: 45,
        status: 'In Progress',
        assignedDCA: 'DCA #1',
        createdDate: 'Jan 5, 2026',
        priorityScore: 8.5,
    },
    {
        id: 2,
        customerName: 'Tech Solutions',
        amountOwed: 3500,
        daysOverdue: 32,
        status: 'Assigned',
        assignedDCA: 'DCA #2',
        createdDate: 'Jan 6, 2026',
        priorityScore: 7.8,
    },
    {
        id: 3,
        customerName: 'Global Traders',
        amountOwed: 12000,
        daysOverdue: 60,
        status: 'In Progress',
        assignedDCA: 'DCA #1',
        createdDate: 'Jan 4, 2026',
        priorityScore: 9.2,
    },
    {
        id: 4,
        customerName: 'Local Business',
        amountOwed: 2000,
        daysOverdue: 15,
        status: 'Assigned',
        assignedDCA: 'DCA #3',
        createdDate: 'Jan 8, 2026',
        priorityScore: 4.5,
    },
    {
        id: 5,
        customerName: 'Enterprise Inc',
        amountOwed: 8500,
        daysOverdue: 50,
        status: 'Closed',
        assignedDCA: 'DCA #1',
        createdDate: 'Jan 3, 2026',
        priorityScore: 8.9,
    },
    {
        id: 6,
        customerName: 'StartUp XYZ',
        amountOwed: 1500,
        daysOverdue: 20,
        status: 'In Progress',
        assignedDCA: 'DCA #2',
        createdDate: 'Jan 7, 2026',
        priorityScore: 5.2,
    },
    {
        id: 7,
        customerName: 'Manufacturing Co',
        amountOwed: 9500,
        daysOverdue: 55,
        status: 'Assigned',
        assignedDCA: 'DCA #3',
        createdDate: 'Jan 2, 2026',
        priorityScore: 8.7,
    },
    {
        id: 8,
        customerName: 'Retail Chain',
        amountOwed: 4200,
        daysOverdue: 35,
        status: 'In Progress',
        assignedDCA: 'DCA #2',
        createdDate: 'Jan 6, 2026',
        priorityScore: 7.5,
    },
];
